<template>
    <vgloballayout
        :loading="loading"
        :error="error"
        @reload="loadInfo"
    >
        <div slot=body>
            <h1>Редактировать вакансию</h1>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">

                <el-form-item label="Название вакансии" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>

                <el-form-item label="Описание вакансии" prop="description">
                    <el-input :rows="15" type="textarea" v-model="ruleForm.description"></el-input>
                </el-form-item>

                <el-form-item label="График" prop="schedule">
                    <el-input v-model="ruleForm.schedule"></el-input>
                </el-form-item>

                <el-form-item label="З/П" prop="wage">
                    <el-input v-model="ruleForm.wage"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button @click="resetForm()">Назад</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">Сохранить</el-button>
                </el-form-item>

            </el-form>
        </div>
    </vgloballayout>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            error: false,
            ruleForm: {
                name: '',
                description : '',
                schedule: '',
                wage: '',
                id: null
            },
            rules: {
                description: [
                    { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
                    { min: 0, max: 40000, message: 'Максимум 40000 символов', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
                    { min: 0, max: 100, message: 'Максимум 100 символов', trigger: 'blur' }
                ],
                schedule: [
                    { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
                    { min: 0, max: 100, message: 'Максимум 100 символов', trigger: 'blur' }
                ],
                wage: [
                    { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
                    { min: 0, max: 100, message: 'Максимум 100 символов', trigger: 'blur' }
                ],
            }
        }
    },
    mounted() {
        this.loadInfo()
    },
    methods: {
        async loadInfo() {
            this.loading = true
            this.error = false

            try {
                let query = await this.$store.dispatch('vacancyDetails', {
                    id: this.$route.params.id
                })

                for(let key in query) {
                    this.ruleForm[key] = query[key]
                }
            } catch(e) {
                this.error = this.$ErrorsMod(e)
            }
            
            this.loading = false
        },
        submitForm(formName) {
            this.$refs[formName].validate( async (valid) => {
                if (valid) {
                    try {
                        await this.$store.dispatch('vacancyEdit', this.ruleForm)
                        this.$message({
                            message: 'Вакансия обновлена',
                            type: 'success'
                        });
                        setTimeout(() => {
                             this.$router.push({path: '/vacancies/'})
                        }, 1000);
                    } catch(e) {
                        this.$ErrorsMod(e)
                    }
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$router.push({path: '/vacancies'})
        }
    }
}
</script>
